export function Spinner({ label }: { label?: string }): JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-10 text-slate-500">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-300 border-t-brand" />
      {label ? <p className="text-sm">{label}</p> : null}
    </div>
  );
}

export function FullScreenSpinner({ label }: { label?: string }): JSX.Element {
  return (
    <div className="flex min-h-full flex-1 items-center justify-center">
      <Spinner label={label} />
    </div>
  );
}
